import { AppLoading } from '@/components/AppLoading'
import Step2Wrapper from '@/containers/steps/vehicle/Step2/Step2Wrapper'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import OffersAddonProvider from '@/context/OffersAddonProvider'

import { OffersVehicleProvider } from '@/context/OffersVehicleProvider'
import { PrintProvider } from '@/context/PrintContext'
import { QuotesProvider } from '@/context/QuotesContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'


export function Step2Page() {
  return (
    <PrintProvider>
      <StepsProvider currentStepId={2}>
        <SidebarProvider>
          <WizzardHeaderProvider>
            <QuotesProvider>
              <Step2Content />
            </QuotesProvider>
          </WizzardHeaderProvider>
        </SidebarProvider>
      </StepsProvider>
    </PrintProvider>
  )
}

const Step2Content = () => {
  const { insuranceParams } = useInsuranceParams()

  return (
    <>
      {(!insuranceParams) && <AppLoading />}
      {insuranceParams &&
        <OffersVehicleProvider>
          <OffersAddonProvider>
            <Step2Wrapper />
          </OffersAddonProvider>
        </OffersVehicleProvider>
      }
    </>
  )
}
